"use client";
import Pusher from "pusher-js";
/** A tab hidden this long drops its socket; the plan caps concurrent connections. */
export const PUSHER_HIDDEN_DISCONNECT_MS = 5 * 60_000;
let pusher = null;
/**
 * Disconnects after the tab stays hidden for `PUSHER_HIDDEN_DISCONNECT_MS` and
 * reconnects when it becomes visible. pusher-js re-subscribes its channels on
 * reconnect, so existing channel handles keep working.
 */
const releaseWhileHidden = (client) => {
    if (typeof document === "undefined")
        return;
    let timer = null;
    document.addEventListener("visibilitychange", () => {
        if (timer)
            clearTimeout(timer);
        timer = null;
        if (document.visibilityState === "hidden") {
            timer = setTimeout(() => client.disconnect(), PUSHER_HIDDEN_DISCONNECT_MS);
        }
        else {
            client.connect();
        }
    });
};
const getPusher = () => {
    const key = process.env.NEXT_PUBLIC_PUSHER_KEY;
    const cluster = process.env.NEXT_PUBLIC_PUSHER_CLUSTER;
    if (!key || !cluster) {
        return null;
    }
    if (!pusher) {
        pusher = new Pusher(key, {
            cluster,
        });
        releaseWhileHidden(pusher);
    }
    return pusher;
};
const pusherProxy = { subscribe: (...args) => getPusher()?.subscribe(...args) ?? null };
export default pusherProxy;
